import { render } from "./ShowerHeadTypeRenderer.vue?vue&type=template&id=f03b3cc4&scoped=true"
import script from "./ShowerHeadTypeRenderer.vue?vue&type=script&lang=js"
export * from "./ShowerHeadTypeRenderer.vue?vue&type=script&lang=js"

import "./ShowerHeadTypeRenderer.vue?vue&type=style&index=0&id=f03b3cc4&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f03b3cc4"]])

export default __exports__